<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'company', label: '대상부서', },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
    />

<!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 점검대상</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center"
           v-for="checkbox in form.inspectList"
           v-bind:key="checkbox.id"
      >
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2" >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox
            :readonly="board.readonly"
            v-model="checkbox.check"
            @change="checkForm">
          </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    표-->
    <div
      v-for="(inspection, indexRows) in form.inspectList"
      v-bind:key="inspection.id"
    >
      <table-inspect-merge
        v-if="inspection.check"
        :is-print="isPrint"
        :is-readonly="board.readonly"
        :title="inspection.title"
        table-header-title="착안사항"
        :table-header-check="[
            { text: '적정', width: '82' },
            { text: '미흡', width: '82' },
            { text: '해당없음', width: '82' },
        ]"
        contentBefore="numbering"
        :is-note="false"
        v-model="inspection.list"
        class="mt-5"
      />

    </div>

<!--    현장근로자 의견 청취 및 특이사항-->
    <div class="grid grid-cols-12 gap-x-6">
      <vs-row class="mt-8 col-span-12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 현장근로자 의견 청취 및 특이사항</h5>
        </vs-col>
      </vs-row>
      <div class="col-span-4 flex items-center mt-4">
        <div class="label-text mr-4">현장근로자 의견 청취</div>
        <p v-if="isPrint" class="print-input">
          {{ form.inputC_1.fileName }}
        </p>
        <file-uploader
          v-else
          :readonly="board.readonly"
          v-model="form.inputC_1"
          class="flex-1 w-full"
        />

      </div>
      <div class="col-span-12 flex items-start mt-4">
        <div class="label-text mr-4 mt-2">특이사항</div>
        <span v-if="isPrint" class="print-textarea"> {{ form.inputC_2 }} </span>
        <ml-textarea
          v-else
          class="flex-1 w-full"
          rows="5"
          v-model="form.inputC_2"
          :readonly="board.readonly"
        />
      </div>
    </div>


    <!--    사진대지-->
    <div class="mt-component-form">
<!--      <vs-row class="my-4">-->
<!--        <vs-col-->
<!--        ><h5><i class="dot"></i>관련사진</h5></vs-col-->
<!--        >-->
<!--      </vs-row>-->
      <div class="flex justify-between items-center mt-8 mb-4">
        <!-- Title -->
        <h5 class="flex-1 flex items-center"><i class="dot"></i>개선 전, 후 사진</h5>

        <!-- Controller -->
        <div v-if="!isPrint">
          <vs-button color="secondary" @click="handleAdd"> 사진추가 </vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove"> 선택삭제 </vs-button>
        </div>
      </div>
      <div class="grid grid-cols-12 h-upload mb-4" v-for="(item, index) in form.photoList">

        <div class="col-span-6 upload-content m-1" style="position:relative;">
<!--          <div class="upload-content__title">-->
<!--            개선 전 사진-->
<!--          </div>-->
          <vs-checkbox v-if="!isPrint" v-model="item.checked" class="mt-2 z-20 absolute left-0 top-0" />

          <div class="upload-content__file">
            <FileUploaderTransparent
              v-if="!isPrint"
              type="only-image"
              v-model="item.file1"
            />
            <img :src="item.file1.thumb" v-else class="w-full h-full" />
          </div>
        </div>

        <div class="col-span-6 upload-content m-1">
<!--          <div class="upload-content__title">-->
<!--            개선 전 사진-->
<!--          </div>-->

          <div class="upload-content__file">
            <FileUploaderTransparent
              v-if="!isPrint"
              type="only-image"
              v-model="item.file2"
            />
            <img :src="item.file2.thumb" v-else class="w-full h-full" />
          </div>
        </div>

        <div class="col-span-6 m-1">
          <ml-input class="w-full" v-model="item.file1.comment" :readonly="board.readonly" placeholder="개선 전"/>

          <div class="flex mt-2">
            <div style="width: 100px; align-self: center;">위치</div>
            <ml-input v-if="!isPrint" class="w-full" v-model="item.file1.position"/>
            <p v-else style="align-self: center;">{{item.file1.position}}</p>
          </div>

          <div class="flex mt-2">
            <div style="width: 100px; align-self: center;">내용</div>
            <ml-input v-if="!isPrint" class="w-full" v-model="item.file1.content"/>
            <p v-else style="align-self: center;">{{item.file1.content}}</p>
          </div>

          <div class="flex mt-2">
            <div style="width: 100px; align-self: center;">대책사항</div>
            <ml-input v-if="!isPrint" class="w-full" v-model="item.file1.against"/>
            <p v-else style="align-self: center;">{{item.file1.against}}</p>
          </div>
        </div>

        <div class="col-span-6 m-1">
          <ml-input class="w-full" v-model="item.file2.comment" :readonly="board.readonly" placeholder="개선 후"/>

          <div class="flex mt-2">
            <div style="width: 100px; align-self: center;">위치</div>
            <ml-input v-if="!isPrint" class="w-full" v-model="item.file2.position"/>
            <p v-else style="align-self: center;">{{item.file2.position}}</p>
          </div>

          <div class="flex mt-2">
            <div style="width: 100px; padding-top: 10px;">개선사항</div>
            <ml-textarea v-if="!isPrint" class="w-full" v-model="item.file2.content" rows="3"/>
            <p v-else style="align-self: center;">{{item.file2.content}}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploader from '@/components/FileUploader'
import TableInspectMerge from "@/components/TableInspectMerge";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import FileUploaderTransparent from "@/components/FileUploaderTransparent.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";

export default {
  components: {
    CompanySelector,
    FileUploaderTransparent,
    FieldSelector,
    TableInspectMerge,
    FileUploader,
    FieldSelectModule,
    FileUploadModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectList || this.form.inspectList.length === 0) {
          this.form.inspectList = this.inspectTable
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        value.title = this.board.writer.department;
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm () {
      this.form.typeTitleList = []
      for (const data of this.form.inspectList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label)
        }
      }
    },
    handleAdd() {
      this.form.photoList.push({file1:{},file2:{}})
    },
    handleRemove() {
      const removeList = []
      for (const item of this.form.photoList) {
        if (item.checked) {
          removeList.push(item)
        }
      }
      for (const item of removeList) {
        this.form.photoList.splice(this.form.photoList.indexOf(item), 1)
      }
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        com_name: '',
        inputA_1: '',

        inputC_1: {},
        inputC_2: '',

        typeTitleList: [],
        inspectList: [],
        photoList: [
          {file1:{},file2:{}}
        ],
        fileList: [],
      },
    };
  },
  computed: {
    inspectTable () {
      return [
        {
          id: 1,
          label: '작업장환경',
          check: false,
          title: '작업장환경',
          list: [
            {
              content: "작업장내 안전통로는 확보되어 있는가?",
              isChecked: "",
            },
            {
              content: "바닥은 미끄럽거나 넘어질 위험이 있는가?",
              isChecked: "",
            },
            {
              content: "출입구, 비상구 주변에 물건을 두고 있는가?",
              isChecked: "",
            },
            {
              content: "이동시 바닥의 상태, 턱, 장애물 유무 확인하는가?",
              isChecked: "",
            },
            {
              content: "물건(이동),사용시 날카로움, 베일 우려가 있는지 확인하는가?",
              isChecked: "",
            },
            {
              content: "계단끝단 미끄럼방지조치, 계단난간 설치 및 이동통로에 적정 조도는 확보되었는가?",
              isChecked: "",
            },
          ],
        },
        // {
        //   id: 2,
        //   label: '건강상태',
        //   check: false,
        //   title: '건강상태',
        //   list: [
        //     {
        //       content: "근로자들의 휴식시간 제공과 휴게시설이 설치 되어 있는가?",
        //       isChecked: "",
        //     },
        //     {
        //       content: "근로자의 건강보호 유지를 위하여 정기적인 건강 검진을 실시하고 있는가?",
        //       isChecked: "",
        //     },
        //   ],
        // },
        {
          id: 3,
          label: '전기안전',
          check: false,
          title: '전기안전',
          list: [
            {
              content: "멀티탭 먼지없이 청결하게 유지되고 있는지 여부 확인",
              isChecked: "",
            },
            {
              content: "전기안전(전열기구,전선,콘센트 등)육안점검 - 문어발식 연결 상태, 전선의 피복 손상, 커버 파손 여부 등",
              isChecked: "",
            },
            {
              content: "전선이 꼬이거나 무거운 물건에 눌려있는지 여부 확인(육안점검)",
              isChecked: "",
            },
          ],
        },
        {
          id: 4,
          label: '비상구',
          check: false,
          title: '비상구',
          list: [
            {
              content: "비상시 사무실 내에서 탈출할 수 있는 비상구가 마련되어 있는가?",
              isChecked: "",
            },
            {
              content: "비상구임을 알아볼 수 있는 표시를 근로자의 눈에 띄기 쉬운 곳에 부착하였는가?",
              isChecked: "",
            },
          ],
        },
        // {
        //   id: 5,
        //   label: '근골격계질환',
        //   check: false,
        //   title: '근골격계질환',
        //   list: [
        //     {
        //       content: "장시간 앉아있는 자세로 작업하는가?(하루 4시간 이상)",
        //       isChecked: "",
        //     },
        //     {
        //       content: "하루 4시간 이상 집중적으로 자료입력 등을 위한 키보드/마우스 조작작업에 해당이 되는가?",
        //       isChecked: "",
        //     },
        //     {
        //       content: "하루 4시간 이상 거북목 유지 등 불안정한 자세로 작업하는가?",
        //       isChecked: "",
        //     },
        //   ],
        // },
        {
          id: 6,
          label: '소방안전',
          check: false,
          title: '소방안전',
          list: [
            {
              content: "소화기의 충전 상태는?",
              isChecked: "",
            },
            {
              content: "소화기 호스의 균열 및 노즐의 파손 상태는?",
              isChecked: "",
            },
            {
              content: "소화기의 월별 점검표 및 사용법 부착 상태는?",
              isChecked: "",
            },
            {
              content: "대피로는 제대로 확보 되어 있는가?",
              isChecked: "",
            },
            {
              content: "소화기는 눈에 띄는 곳에 비치되어 있는가?",
              isChecked: "",
            },
          ],
        },
        {
          id: 7,
          label: '게시',
          check: false,
          title: '게시',
          list: [
            {
              content: "산업안전보건법령요지 게시 여부",
              isChecked: "",
            },
            {
              content: "경영방침 게시 여부",
              isChecked: "",
            },
            {
              content: "안전보건관리규정 게시 여부",
              isChecked: "",
            },
            {
              content: "안전보건표지 게시 여부",
              isChecked: "",
            },
            {
              content: "중량물 취급주의 표지 부착 여부",
              isChecked: "",
            },
          ],
        },
        {
          id: 8,
          label: '보호구',
          check: false,
          title: '보호구',
          list: [
            {
              content: "적절한 보호구는 지급하고 있는가?",
              isChecked: "",
            },
            {
              content: "적절한 보호구는착용하고 있는가?",
              isChecked: "",
            },
            {
              content: "보호구의 주기적인 점검 및 교체 여부",
              isChecked: "",
            },
            {
              content: "보호구 지급대장 작성하고 있는가?",
              isChecked: "",
            },
          ],
        },
        // {
        //   id: 9,
        //   label: '교육',
        //   check: false,
        //   title: '교육',
        //   list: [
        //     {
        //       content: "신규 근로자의 경우 안전보건교육을 실시하고 있는가?",
        //       isChecked: "",
        //     },
        //     {
        //       content: "근로자의 특별교육 해당일 경우 이를 실시하고 있는가?",
        //       isChecked: "",
        //     },
        //   ],
        // },
        {
          id: 10,
          label: '화학물질',
          check: false,
          title: '화학물질',
          list: [

            {
              content: "유해·위험물질 취급 및 보관상태 확인",
              isChecked: "",
            },
            {
              content: "물질안전보건자료(MSDS) 게시 여부",
              isChecked: "",
            },
            {
              content: "소분용기 경고표지 부착 여부",
              isChecked: "",
            },
            {
              content: "특별관리물질 취급 및 관리 상태",
              isChecked: "",
            },
          ],
        },
        {
          id: 11,
          label: '밀폐공간',
          check: false,
          title: '밀폐공간',
          list: [
            {
              content: "밀폐공간 작업프로그램 수립 및 운영 여부",
              isChecked: "",
            },
            {
              content: "밀폐공간 출입금지표지 부착 여부",
              isChecked: "",
            },
          ],
        },
        // {
        //   id: 12,
        //   label: '근로자',
        //   check: false,
        //   title: '근로자',
        //   list: [
        //     {
        //       content: "구급함 관리 상태 이상 여부",
        //       isChecked: "",
        //     },
        //     {
        //       content: "바른 작업자세 및 작업도구 사용 여부",
        //       isChecked: "",
        //     },
        //     {
        //       content: "건강진단 실시 여부",
        //       isChecked: "",
        //     },
        //   ],
        // },
        {
          id: 13,
          label: '휴게시설',
          check: false,
          title: '휴게시설',
          list: [

            {
              content: "휴게시설 관리 상태 이상 여부",
              isChecked: "",
            },
            {
              content: "구급함 관리 상태 이상 여부",
              isChecked: "",
            },
          ],
        },
        // {
        //   id: 14,
        //   label: '환기/배기장치',
        //   check: false,
        //   title: '환기/배기장치',
        //   list: [
        //     {
        //       content: "환기상태 및 환기설비 작동상태는 적절한가?",
        //       isChecked: "",
        //     },
        //     {
        //       content: "국소 배기장치 상태 및 작동, 관리는 적절한가?",
        //       isChecked: "",
        //     },
        //   ],
        // },
      ]
    }
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }
}
</style>
